/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Platforms_Web_DescInputs */

const en_fc_home_platforms_web_desc = /** @type {(inputs: Fc_Home_Platforms_Web_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The WebAssembly build runs in Chrome, Edge and other WebGPU browsers. Nothing to install, and your media stays on your computer.`)
};

/**
* | output |
* | --- |
* | "The WebAssembly build runs in Chrome, Edge and other WebGPU browsers. Nothing to install, and your media stays on your computer." |
*
* @param {Fc_Home_Platforms_Web_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_platforms_web_desc = /** @type {((inputs?: Fc_Home_Platforms_Web_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Platforms_Web_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_platforms_web_desc(inputs)
});
export { fc_home_platforms_web_desc as "fc.home.platforms.web.desc" }